import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WorkerService } from '@/infra/services/worker';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CreateWorkerParams {
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = WorkerService.getInstance();

export const useCreateWorker = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateWorkerParams) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_WORKER]);
			message.success(I18n.get('Worker created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on create worker'));
		}
	});
};
